{
  "name": "hcp-webapp",
  "version": "2.4.0-alpha.39",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:andre": "ng serve --host=0.0.0.0 --disable-host-check --configuration=andre --port=6200",
    "start:severin": "ng serve --host=0.0.0.0 --disable-host-check --configuration=severin --port=4600",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.0",
    "@angular/cdk": "^21.2.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/material": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "bootstrap": "^5.3.8",
    "deepmerge": "^4.3.1",
    "js-sha256": "^0.11.1",
    "lottie-web": "^5.12.0",
    "ngx-auth-util-lib": "3.0.0",
    "ngx-heka-design-lib": "4.0.17",
    "ngx-lottie": "^21.2.0",
    "ngx-matomo-client": "^9.0.1",
    "ngx-progressbar": "^14.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.0",
    "@angular/cli": "~21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@types/node": "^20.2.3",
    "typescript": "~5.9.3"
  }
}
